<!-- eslint-disable max-lines -->
<template>
    <paper id="agingProduct">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            @saveData="saveData"
            @row-db-click="rowDBclick"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @switch-change="switchChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @btnClick="btnClick"
            searchId="test"
            pageID="test"
        >
        <div slot="table-module-btn">
            <reportExport #default="{ submit }" :reportCode="reportCode">
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <span v-has="'03040001'" class="mgl-10">
                    <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                    </span>
                </el-tooltip>
            </reportExport>
        </div>
        </m-pane>
        <detail-dialog ref="DetailDialog"></detail-dialog>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './config.json';
import paper from '@/components/core/paper/Paper';
import { getCenterInv } from '../../../api/stockManage';
import DetailDialog from './_detailDialog';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapState } from 'vuex';

const reportCodeActions = {
    custInv: 'REPORT_OTP_INVENTORY_CENTER_CUSTINV',
    whInv: 'REPORT_OTP_INVENTORY_CENTER_WHINV',
    siteInv: 'REPORT_OTP_INVENTORY_CENTER_SITEINV'
};
export default {
    components: { mPane, paper, DetailDialog, reportExport },
    data() {
        return {
            config: config,
            totalData: [],
            loading: false,
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            exportParams: {},
            isFirstSearch: true,
            reportCode: 'REPORT_OTP_INVENTORY_CENTER_CUSTINV'
        };
    },
    methods: {
        _validateSearchParams() {
            if (!(this.searchParams.invType && this.searchParams.siteCode)) {
                return '库存类型和平台不能为空！';
            }
        },
        async getList() {
            if (this._validateSearchParams()) return this.$message.warning(this._validateSearchParams());
            this.isFirstSearch = false;
            this.loading = true;
            this.$refs.tablePage.changeLoading(true);
            this.searchParams.itemName = this.searchParams.itemName ? this.searchParams.itemName.replace(/{/g, '%7b').replace(/}/g, '%7d').replace(/\[/g, '%5b').replace(/\]/g, '%5d') : '';
            await getCenterInv(this.searchParams).then(res => {
                if (res) {
                    if (res.data.totalPage !== 0 && this.searchParams.pageNo > res.data.totalPage) {
                        this.searchParams.pageNo = res.data.totalPage;
                        this.getList();
                    } else {
                        this.totalData = res.data.list || [];
                        this.pageTotal = res.data.totalCount;
                    }
                } else {
                    this.totalData = [];
                }
            }).finally(() => {
                this.loading = false;
                this.$refs.tablePage.changeLoading(false);
            });
        },
        rowDBclick(row) {
            // 表格内双击事件
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
            this.visible = true;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
        },
        btnClick(val, index, row) {
            this.$refs['DetailDialog'].show(true, row);
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectRow = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchChange(data) {
            // if (!data.invType) {
            //     data.invType = 'whInv';
            // }
            this.searchParams = { ...this.searchParams, ...data, pageNo: 1 };
            if (this.searchParams.itemCodes && this.searchParams.itemCode) delete this.searchParams.itemCodes;
            this.exportParams = { ...this.searchParams };
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getList();
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
        },
        saveData(data) {
            // 表格新增修改后返回数据
        },
        redomet(data) {
            // 这是删除方法
        },
        refresh() {
            // 表格内刷新按钮
        },
        async exportFile(submit) {
            const isFirstSearch = this.isFirstSearch;
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            if (this.isFirstSearch) {
                this.searchParams = this.$refs.tablePage.$refs.searchList.onSearchChange({}, true);
                this.reportCode = reportCodeActions[this.searchParams.invType] || '';
                this.exportParams = { ...this.searchParams };
                await this.getList();
            }
            if (this._validateSearchParams()) return isFirstSearch ? '' : this.$message.warning(this._validateSearchParams());
            submit({
                ...this.exportParams,
                tenantCode: this.currentTenant.tenantCode,
                beginDate2: '2020-11-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate2: '2020-11-27 00:00:00',
                itemCodes: this.strToArr(this.exportParams.itemCodes) // 订单跳过来的可能多个
            });
            this.isFirstSearch = false;
        },
        strToArr(str) {
            if (str) return str.split(',');
            return [];
        }
    },
    beforeRouteEnter (to, from, next) {
        if (from.path === '/order-manage/order-center' || from.path === '/order-manage/order-detail') {
            next(vm => {
                if (vm.$route.params.invType) {
                    if (vm.$refs.tablePage.$refs.searchList.searchData.itemCode) {
                        delete vm.$refs.tablePage.$refs.searchList.searchData.itemCode;
                        delete vm.$refs.tablePage.$refs.searchList.searchData.itemName;
                    }
                    vm.$refs.tablePage.$refs.searchList.searchData = {
                        ...vm.$refs.tablePage.$refs.searchList.searchData,
                        ...vm.$route.params
                    };
                    vm.$refs.tablePage.$refs.searchList.onSearchChange();
                }
            });
        } else {
            next();
        }
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant
        })
    }
};
</script>
